import React from "react";
import useModelDetail from "../../customHooks/ModelDetail/useModelDetail";
import { useParams } from "react-router";
import classes from "./ModelDetailPage.module.css";
import { Toaster } from "react-hot-toast";
import { Loader as LoaderIcon } from "react-feather";
import { MdOutlineKeyboardBackspace } from "react-icons/md";

const ModelDetailPage = () => {
  const { id } = useParams();
  const {
    modelDetails,
    products,
    isImageUploaded,
    errorMessage,
    handleImageChange,
    handleDelete,
    setIsDeleteConfirmationOpen,
    navigate,
    isDeleteConfirmationOpen,
    imageLoader,
    updateModel,
    isLoading,
    edit,
    selectedImage,
    handleModelImageChange,
    imgWidth,
  } = useModelDetail({ id });
  return (
    <>
      {" "}
      <Toaster position="top-center" reverseOrder={false} gutter={8} />
      <div className="min-h-screen">
        <div className={classes.topheader}>
          <div className="flex items-center justify-between">
            <h1 className={`p-1 ${classes.titlename}`}>Models</h1>
            <button
              className={`flex items-center p-2 px-3 text-white rounded justify-center`}
              style={{ backgroundColor: "#646af5" }}
              onClick={() => navigate("/modelsandbox")}
            >
              <MdOutlineKeyboardBackspace /> &nbsp; Go Back
            </button>
          </div>
        </div>

        <div className={classes.middle_main_container}>
          {modelDetails && (
            <div className="bg-white rounded-lg grid md:grid-cols-[1fr_2fr] grid-cols-1 h-[800px]">
              <div className="flex-1 flex flex-col justify-center">
                {!isImageUploaded ? (
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Upload Image
                    </label>
                    <div
                      className="relative flex justify-center items-center w-full h-48 p-6 border-2 border-dashed border-gray-300 rounded-md cursor-pointer hover:border-gray-500"
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                      onDrop={(e) => {
                        e.preventDefault();
                        handleImageChange({
                          target: { files: e.dataTransfer.files },
                        });
                      }}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      {!isLoading ? (
                        <>
                          <div className="text-center">
                            <div className="text-sm text-gray-600 mt-2">
                              <p>
                                Drag & Drop your image here or click to select
                              </p>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="flex justify-center items-center">
                          <div
                            className={`loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-16 w-16`}
                          ></div>
                        </div>
                      )}
                      <input
                        id="file-upload"
                        type="file"
                        accept="image/*"
                        className="sr-only"
                        onChange={handleImageChange}
                      />
                    </div>
                    {errorMessage && (
                      <p className="text-red-500 text-xs mt-1">
                        {errorMessage}
                      </p>
                    )}
                  </div>
                ) : (
                  <>
                    <div
                      className={` flex-shrink-0 ${classes.renderedmodelImages} m-[40px]`}
                    >
                      <div
                        style={{ padding: "15px" }}
                        className="flex items-center justify-center bg relative bg-[#f4f7fb] shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                      >
                        <div className="bg-white rounded-xl p-[10px]">
                          <div
                            className="bg-gray-300 flex-shrink-0 "
                            style={{
                              position: "relative",
                              width: imgWidth,
                              height: "500px",
                              // height: "500px",
                            }}
                          >
                            <img
                              src={selectedImage.sURL}
                              className="h-full w-full"
                            />
                            <div className="demo"></div>
                            <div className="demo0"></div>
                            <div className="demo1"></div>
                            <div className="demo2"></div>
                            <div className="demo3"></div>
                          </div>
                        </div>
                      </div>

                      {/* last div */}
                    </div>

                    <div className={classes.productsliderthumbnails}>
                      {modelDetails.aImageJson && (
                        <div
                          className={`d-flex align-items-center justify-content-center gap-5 ${classes.productsliderthumbnailsImg}`}
                        >
                          {JSON.parse(modelDetails?.aImageJson).map((image) => (
                            <div
                              key={image.iGalleryId}
                              style={{
                                height: "100px",
                                width: "100px",
                                padding: "5px",
                              }}
                              className={`flex items-center justify-center border rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-200 ${
                                selectedImage === image.iGalleryId
                                  ? "border-blue-500 shadow-lg"
                                  : "border-gray-300"
                              }`}
                              onClick={() => handleModelImageChange(image)}
                            >
                              <img
                                src={image.sURL}
                                className="h-full w-full object-contain rounded-lg"
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
              {isDeleteConfirmationOpen && (
                <div className={classes.modal_overlay}>
                  <div className={classes.modal_content}>
                    <p>Are you sure you want to delete this model?</p>
                    <button
                      onClick={(e) => {
                        handleDelete(id);
                      }}
                    >
                      Confirm
                    </button>
                    <button onClick={() => setIsDeleteConfirmationOpen(false)}>
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              <div className={` ${classes.modaldetailrightsection}`}>
                <div
                  className={`flex justify-between items-center ${classes.modaldetailtext}`}
                >
                  <h2>Model Details</h2>
                  {/* <button
                    onClick={handleDeleteClick}
                    className="text-3xl font-semibold text-gray-800"
                  >
                    <MdDelete size={25} />
                  </button> */}
                </div>

                <div
                  className={`space-y-4 my-4 ${classes.modaldetailrightdetaillist}`}
                >
                  <div className="flex items-center space-x-4 border-b pb-2">
                    <span className="text-lg font-medium text-gray-600 w-36">
                      Model Name:
                    </span>
                    <span className={classes.modelRighttitile}>
                      {" "}
                      {modelDetails.sModelName}{" "}
                    </span>
                  </div>

                  <div className="flex items-center space-x-4 border-b pb-2">
                    <span className="text-lg font-medium text-gray-600 w-36">
                      Gender:
                    </span>
                    <span className={classes.modelRighttitile}>
                      {modelDetails.iGenderId === 1 ? "Male" : "Female"}
                    </span>
                  </div>

                  <div className="flex items-center space-x-4 border-b pb-2">
                    <span className="text-lg font-medium text-gray-600 w-36">
                      Body Type:
                    </span>
                    <span className={classes.modelRighttitile}>
                      {modelDetails.sBodyType}
                    </span>
                  </div>

                  <div className="flex items-center space-x-4">
                    <span className="text-lg font-medium text-gray-600 w-36">
                      Tag:
                    </span>
                    <span className={classes.modelRighttitile}>
                      {modelDetails.sTag}
                    </span>
                  </div>
                  {edit ? (
                    <div className="mt-6 flex justify-end">
                      {imageLoader ? (
                        <button
                          className="screenFormSubmitLoaderBtn consistentBtn w-1/4 bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800"
                          disabled={imageLoader}
                        >
                          <LoaderIcon size={20} className="indicator" />
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className={`w-1/4 px-4 py-2 rounded-md text-white ${
                            isImageUploaded
                              ? "bg-black hover:bg-gray-800 cursor-pointer"
                              : "bg-gray-400 cursor-not-allowed"
                          }`}
                          onClick={updateModel}
                          disabled={!isImageUploaded}
                        >
                          Save Image
                        </button>
                      )}
                    </div>
                  ) : null}
                </div>

                {/* <div className="mt-4 space-y-2" style={{ width: "50%" }}>
                <select
                  name="status"
                  value={filters.status}
                  // disabled
                  onChange={handleFilterChange}
                  className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option>Select Status</option>
                  {filterOptions.statusOptions.map((option) => (
                    <option key={option.iStatusId} value={option.iStatusId}>
                      {option.sName}
                    </option>
                  ))}
                </select>
                <select
                  name="bodyType"
                  value={filters.bodyType}
                  // disabled
                  onChange={handleFilterChange}
                  className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option>Select Body Type</option>
                  {filterOptions.bodyTypeOptions.map((option) => (
                    <option key={option.iBodyTypeId} value={option.iBodyTypeId}>
                      {option.sName}
                    </option>
                  ))}
                </select>
                <select
                  name="gender"
                  // disabled
                  value={filters.gender}
                  onChange={handleFilterChange}
                  className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option>Select Gender</option>
                  {filterOptions.genderOptions.map((option) => (
                    <option key={option.iGenderId} value={option.iGenderId}>
                      {option.sName}
                    </option>
                  ))}
                </select>
                <select
                  name="company"
                  // disabled
                  value={filters.company}
                  onChange={handleFilterChange}
                  className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option>Select Company</option>
                  {filterOptions.companyOptions.map((option) => (
                    <option key={option.iStoreId} value={option.iStoreId}>
                      {option.sName}
                    </option>
                  ))}
                </select>
              </div> */}
              </div>
            </div>
          )}

          {isImageUploaded ? (
            <>
              {products.length ? (
                <div className="bg-white p-6 rounded-lg shadow-lg mb-6 mt-10 h-[700px]">
                  <div className="flex items-center justify-between mb-4">
                    <div className={classes.renderedText}>
                      Rendered Model Images
                    </div>
                  </div>

                  <div className="overflow-x-auto flex space-x-4 h-full">
                    {products.map((product, modalIndex) => (
                      <div
                        key={modalIndex}
                        className={` flex-shrink-0 ${classes.renderedmodelImages}`}
                      >
                        <div
                          style={{ padding: "15px" }}
                          className="flex items-center justify-center bg relative bg-[#f4f7fb] shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                        >
                          <div className="bg-white rounded-xl p-[10px]">
                            <div
                              className="bg-gray-300 flex-shrink-0 "
                              style={{
                                position: "relative",
                                width: imgWidth,
                                height: "500px",
                                // height: "500px",
                              }}
                            >
                              <img
                                src={selectedImage.sURL}
                                alt={`Modal ${modalIndex}`}
                                className="h-full w-full"
                              />
                              {product?.position ? (
                                <>
                                  {selectedImage.iBodyTypeId === 2 ? (
                                    <>
                                      {product?.position?.map(
                                        (position, index) => (
                                          <img
                                            key={index}
                                            src={product.sURL}
                                            style={{
                                              position: "absolute",
                                              top: `${position.top}px`,
                                              left: `${position.left}px`,
                                              width: `${position.width}px`,
                                              height: `${position.height}px`,
                                              transform: `translateX(-50%)`,
                                            }}
                                          />
                                        )
                                      )}
                                    </>
                                  ) : selectedImage.iBodyTypeId === 3 ? (
                                    <>
                                      {product?.position?.map(
                                        (position, index) => (
                                          <img
                                            key={index}
                                            src={product.sURL}
                                            style={{
                                              position: "absolute",
                                              top: `${position.top}px`,
                                              left: `${position.left}px`,
                                              width: `${position.width}px`,
                                              height: `${position.height}px`,
                                              transform: `translate(-50%, -50%) rotate(${position.rotationAngle}deg)`,
                                            }}
                                          />
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <img
                                      src={product.sURL}
                                      style={{
                                        position: "absolute",
                                        top: `${model?.position.top}px`,
                                        left: `${model?.position.left}px`,
                                        width: `${model?.position.width}px`,
                                        height: `${model?.position.height}px`,
                                        transform: `  ${
                                          product.iBodyTypeId === 4
                                            ? "translateY(50%)"
                                            : product.iBodyTypeId === 1
                                            ? "translate(-50%, -50%)"
                                            : ""
                                        } rotate(${
                                          model?.position.rotationAngle
                                        }deg)`,
                                      }}
                                    />
                                  )}
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        {/* last div */}
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ModelDetailPage;
